const AUTO = 'Attribution automatique';

export default AUTO;
